
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls, } from '@wordpress/block-editor';
import { Button, ButtonGroup, PanelBody, Notice, } from  '@wordpress/components'; 
import './editor.scss';


export default function Edit({ attributes, setAttributes } ) {
	const { backgroundColor,  content, title, speed } = attributes;
	const blockProps = useBlockProps();

	const onChangeContent = ( newContent ) => {
		setAttributes( { content: newContent } )
	}

	const onChangeTitle = ( newTitle ) => {
		setAttributes( { title: newTitle } )
	}

	const speedChange = ( newspeed ) => {
		// Update attributes.
		setAttributes( { speed: newspeed } );
		
	}

	
	return (
		<div { ...blockProps } 
			style={ { backgroundColor: backgroundColor } }
		>
		<InspectorControls>
			<PanelBody title={ __( 'Select Toggle Speed','hide-or-toggle' ) }>
				
			<ButtonGroup aria-label={ __( 'Select speed', 'hide-or-toggle'  ) } >
				{ [ 'slow','fast' ].map( ( speedValue ) => {
					return (
						<Button
						key={ speedValue }
						variant="secondary"
						onClick={ () => speedChange( speedValue ) }
						>
							{ speedValue }
						</Button>
					);
				} ) }
			</ButtonGroup>
			</PanelBody>
			</InspectorControls>
		<RichText 
				tagName='div' 
				className='title'
				value={ title } 
				onChange={onChangeTitle}
				placeholder={__('This is a title placeholder','hide-or-toggle')}
				
				/>
		<RichText 
				tagName='div' 
				className='hidden'
				value={ content } 
				onChange={onChangeContent}
				placeholder={__('This is a content placeholder.','hide-or-toggle')}
				/>
			{ speed === 'slow' && (<span>Slow</span>)}
			{ speed === 'fast' && (<span>Fast</span>)}

		</div>
	);
}
